import React from "react";
import { Link } from "react-router-dom";
import "../css/templatemo-festava-live.css";

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-footer-top">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-12">
              <h2 className="text-white mb-lg-0">SolanaTicket</h2>
            </div>

            {/*<div className="col-lg-6 col-12 d-flex justify-content-lg-end align-items-center">
              <ul className="social-icon d-flex justify-content-lg-end">
                <li className="social-icon-item">
                  <Link to="./index" className="social-icon-link">
                    <span className="bi-twitter"></span>
                  </Link>
                </li>

                <li className="social-icon-item">
                  <a href="#" className="social-icon-link">
                    <span className="bi-apple"></span>
                  </a>
                </li>

                <li className="social-icon-item">
                  <a href="#" className="social-icon-link">
                    <span className="bi-instagram"></span>
                  </a>
                </li>

                <li className="social-icon-item">
                  <a href="#" className="social-icon-link">
                    <span className="bi-youtube"></span>
                  </a>
                </li>

                <li className="social-icon-item">
                  <a href="#" className="social-icon-link">
                    <span className="bi-pinterest"></span>
                  </a>
                </li>
              </ul>
  </div>*/}
          </div>
        </div>
      </div>

      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-12 mb-4 pb-2">
            <h5 className="site-footer-title mb-3">Links</h5>

            <ul className="site-footer-links">
              <li className="site-footer-link-item">
                <Link to="./index" className="site-footer-link">
                  Index
                </Link>
              </li>

              <li className="site-footer-link-item">
                <Link to="./home" className="site-footer-link">
                  Home
                </Link>
              </li>

              {/*<li className="site-footer-link-item">
                <a href="#" className="site-footer-link">
                  Artists
                </a>
              </li>

              <li className="site-footer-link-item">
                <a href="#" className="site-footer-link">
                  Schedule
                </a>
              </li>

              <li className="site-footer-link-item">
                <a href="#" className="site-footer-link">
                  Pricing
                </a>
              </li>

              <li className="site-footer-link-item">
                <a href="#" className="site-footer-link">
                  Contact
                </a>
</li>*/}
            </ul>
          </div>

          <div className="col-lg-3 col-md-6 col-12 mb-4 mb-lg-0">
            <h5 className="site-footer-title mb-3">¿Tienes alguna duda?</h5>

            <p className="text-white d-flex">
              <a
                href="mailto:tmarlonrodriguez2b@gmail.com"
                className="site-footer-link"
              >
                tmarlonrodriguez2b@gmail.com
              </a>
            </p>

            <p className="text-white d-flex">
              <a
                href="mailto:tmarlonrodriguez2b@gmail.com"
                className="site-footer-link"
              >
                tmarlonrodriguez2b@gmail.com
              </a>
            </p>
          </div>

          <div className="col-lg-3 col-md-6 col-11 mb-4 mb-lg-0 mb-md-0">
            <h5 className="site-footer-title mb-3">Location</h5>

            <p className="text-white d-flex mt-3 mb-2">
              Cuidad de México, CDMX
            </p>

            <a className="link-fx-1 color-contrast-higher mt-3" href="https://goo.gl/maps/kBfJDvNNvnfXN4QQ7">
              <span>Our Maps</span>
              <svg className="icon" viewBox="0 0 32 32" aria-hidden="true">
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="16" cy="16" r="15.5"></circle>
                  <line x1="10" y1="18" x2="16" y2="12"></line>
                  <line x1="16" y1="12" x2="22" y2="18"></line>
                </g>
              </svg>
            </a>
          </div>
        </div>
      </div>

      <div className="site-footer-bottom">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-12 mt-5">
              <p className="copyright-text">SolanaTicket</p>
            </div>

            <div className="col-lg-8 col-12 mt-lg-5">
              <ul className="site-footer-links">
                <li className="site-footer-link-item">
                  <a href="#" className="site-footer-link">
                    {/*Terms &amp; Conditions*/}
                  </a>
                </li>

                <li className="site-footer-link-item">
                  <a href="#" className="site-footer-link">
                    {/*Privacy Policy*/}
                  </a>
                </li>

                <li className="site-footer-link-item">
                  <a href="#" className="site-footer-link">
                    {/*Your Feedback*/}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
